<template>
  <div class="career-video-add animatedBox">
    <div class="container fluid">
      <form @submit.prevent="submitForm">
        <div class="card mb-2">
          <h4 class="mainTitle lineBottom">Add Video</h4>
          <div class="main-contents">
            <div class="input-wrapper required mt-2 px-0">
              <label>Youtube Link:</label>
              <input type="text" required v-model="video.videoLink" />
            </div>
          </div>
        </div>

        <div class="btn-wrapper d-flex justify-content-end px-0 mxn-0 sm-mxn-1">
          <button type="submit" class="btn add mx-1">Create</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "career-video-add",
  data() {
    return {
      video: {
        videoLink: "",
      },
    };
  },
  methods: {
    async submitForm() {
      const currentId = this.$route.path.split("/")[3];

      try {
        const request = await this.$store.dispatch(
          "careerVideo/addVideo",
          this.video
        );

        alert("New video uploaded successfully.");
        this.$router.push({ path: "/career-video" });
        return;
      } catch (error) {
        alert("An unexpected error occured. Please try again later.");
        console.log(error);
        throw error;
      }
    },
  },
};
</script>

<style lang="scss">
.career-video-add {
  form {
    @extend %formDesign;
  }
}
</style>